<template>
  <div class="login-footer flex">
    <InlineLanguageSelector :language="language" up />
    <div class="spacer"></div>
  </div>
</template>

<script>
import InlineLanguageSelector from '@component/InlineLanguageSelector.vue'

export default {
  components: { InlineLanguageSelector },
  computed: {
    language() {
      return this.$store?.state?.language ?? Munio.config.i18n
    },
  },
}
</script>
